export var ShipStatus;
(function (ShipStatus) {
    ShipStatus[ShipStatus["ENTERED"] = 1] = "ENTERED";
    ShipStatus[ShipStatus["PACKED"] = 2] = "PACKED";
    ShipStatus[ShipStatus["SHIPPED"] = 3] = "SHIPPED";
    ShipStatus[ShipStatus["DELIVERED"] = 4] = "DELIVERED";
})(ShipStatus || (ShipStatus = {}));
//# sourceMappingURL=ship-status.js.map